import github from './../Assets/github-small.png'

const Projects = ({projects}) => {
       
    console.log(projects)

    return (
        <div className='projects col gy-0 mb-4 px-4 py-3 bg-body-tertiary rounded-3 '>
            <h3 className="text-start">
                    My Projects:
                </h3>

            {
                projects.map((item, index) => 

                <div key={index} className="text-start py-3 border-dark border-top">
                    <h5>{item.title}</h5>
                    <p>{item.description}</p>

                    <a className="button btn active" href={item.url} target='_blank'>

                        <img className="icon-img col github-icon px-2" src={github}></img>
                        Click here
                    </a>
                </div>
                
            )}
            
        </div>
    )
}

export default Projects;